import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon).attrs({ name: 'truck' })`
  display: block;
  margin: 0 auto;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
`;
